interface LegacyGeographyDestination {
  regionSlug: string;
  localitySlug?: string;
}

const LEGACY_GEOGRAPHY_DESTINATIONS: Record<string, LegacyGeographyDestination> = {
  bloomington: { regionSlug: 'hoosier-hills', localitySlug: 'bloomington' },
  ellettsville: { regionSlug: 'hoosier-hills', localitySlug: 'ellettsville' },
  online: { regionSlug: 'online' },
};

export function resolveLegacyGeographyRedirect(pathname: string): string | null {
  const normalizedPath = pathname.replace(/\/+$/, '') || '/';
  const routeMatch =
    normalizedPath.match(/^\/cities\/([^/]+)(?:\/(classes|creators))?$/) ??
    normalizedPath.match(/^\/([^/]+)(?:\/(classes|creators))?$/);

  if (!routeMatch) {
    return null;
  }

  const destination = LEGACY_GEOGRAPHY_DESTINATIONS[routeMatch[1]?.toLowerCase() ?? ''];
  if (!destination) {
    return null;
  }

  const canonicalPath = destination.localitySlug
    ? `/regions/${destination.regionSlug}/${destination.localitySlug}`
    : `/regions/${destination.regionSlug}`;

  return routeMatch[2] ? `${canonicalPath}/${routeMatch[2]}` : canonicalPath;
}
